import { categoryAnimation, categoryImageAnimation } from './homeAnimations';
import { NavService } from './../nav/service/nav.service';
import {
  Component,
  DestroyRef,
  inject,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { Article, Destination } from '../admin/shared/public-api';
import { Title, Meta } from '@angular/platform-browser';
import { Subject, finalize, forkJoin, takeUntil } from 'rxjs';
import { ArticleService, DestinationService } from '../admin/shared/public-api';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpotDirective } from '../shared/directives/spot.directive';
import { ArticleCardComponent } from '../shared/components/article-card/article-card.component';
import { DragDirective } from '../shared/directives/drag.directive';
import { EbookSectionComponent } from '../shared/components/ebook-section/ebook-section.component';
import { AccomodationCardComponent } from '../shared/components/accomodation-card/accomodation-card.component';
import { DeviceService } from '../shared/services/device.service';
import { MetaService } from '../shared/services/meta.service';
import { JSONLDService } from '../shared/services/jsonld.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [categoryAnimation, categoryImageAnimation],
  imports: [
    SpotDirective,
    CommonModule,
    RouterModule,
    NgOptimizedImage,
    AccomodationCardComponent,
    ArticleCardComponent,
    DragDirective,
    EbookSectionComponent,
  ],
})
export class HomeComponent implements OnInit, OnDestroy {
  protected readonly deviceService = inject(DeviceService);
  private readonly metaTagService = inject(MetaService);
  private readonly jsonLdService = inject(JSONLDService);

  canClick = true;
  destinations: Destination[];
  accomodations: Article[];
  lastArticle: Article;
  discoverArticles: Article[];
  belgiumDestination: Destination | undefined;
  $onDestroy = new Subject();

  hoverCategories = {
    destinations: false,
    belgium: false,
    setup: false,
    map: false,
  };

  constructor(
    private readonly destinationService: DestinationService,
    private readonly articleService: ArticleService,
    readonly navService: NavService,
    titleService: Title
  ) {
    navService.setTransparentBackground();

    //#region SEO
    this.jsonLdService.insertSchema();

    const baseUrl = environment.baseUrl;
    const description = `Blog voyages belge, aventures et découvertes en Belgique et dans le monde. Logements insolites et aventures à vélo.`;
    const title = `Les Explorateurs du Monde - Blog voyages belge`;
    titleService.setTitle(title);

    this.metaTagService.updateMetaTags(
      description,
      title,
      baseUrl,
      'website',
      `${baseUrl}og_img.png`,
      768,
      432,
      'image/png'
    );
    //#endregion
  }

  ngOnInit(): void {
    this.destinationService
      .getDestinations()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((destinations: Destination[]) => {
        this.destinations = destinations.sort(
          (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
        );
        this.belgiumDestination = destinations.find(
          (x) => x.country === 'Belgique' || x.country === 'Belgium'
        );
      });
    forkJoin({
      lastArticles: this.articleService.getLastArticles(3),
      randomArticles: this.articleService.getRandomArticles(),
      accomodations: this.articleService.getAccomodations(0, 3),
    })
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((x) => {
        this.lastArticle = x.lastArticles[0];
        if (this.deviceService.isMobile()) {
          this.discoverArticles = x.lastArticles;
        } else {
          this.discoverArticles = [...x.lastArticles, ...x.randomArticles];
        }
        this.accomodations = x.accomodations;
      });
  }

  navigateTo(url: string): void {
    window.location.href = url;
  }

  ngOnDestroy(): void {
    this.jsonLdService.removeStructuredData();
  }

  hoverCategory(category: 'map' | 'belgium' | 'setup' | 'destinations', state: boolean): void {
    this.hoverCategories[category] = state;
  }
}
